export default {
    pmtags_main_title: 'Etiquetas',
    pmtags_main_label: 'Etiqueta',
    pmtags_main_accounts: 'Cuentas',
    pmtags_main_devices: 'Dispositivos',
    pmtags_main_edit_tag: 'Editar',
    pmtags_main_delete_tag: 'Eliminar',
    pmtags_main_add_tag: 'Agregar Etiqueta',

};